import { FirebaseError } from "firebase/app";

// Maps Firebase Auth error codes to user-facing Romanian copy. Anything we
// don't recognize falls back to a generic message.
export function authErrorMessage(err: unknown): string {
  if (err instanceof FirebaseError) {
    switch (err.code) {
      case "auth/wrong-password":
      case "auth/invalid-credential":
      case "auth/invalid-login-credentials":
        return "Parola curentă este greșită.";
      case "auth/email-already-in-use":
        return "Emailul este deja folosit de alt cont.";
      case "auth/invalid-email":
        return "Email invalid.";
      case "auth/weak-password":
        return "Parola este prea slabă (minim 6 caractere).";
      case "auth/requires-recent-login":
        return "Sesiunea a expirat. Deconectează-te și conectează-te din nou.";
      case "auth/too-many-requests":
        return "Prea multe încercări. Încearcă din nou peste câteva minute.";
      case "auth/network-request-failed":
        return "Nu există conexiune la internet. Verifică rețeaua și încearcă din nou.";
    }
  }
  return "A apărut o eroare. Încearcă din nou.";
}
